import styled, { createGlobalStyle } from "styled-components";

import VStack from "shared/components/layout/stack/VStack";

export const StyledContactCard = createGlobalStyle`
    .contact-card{
        width:max-content;
    }
`;

export const DetailsWrapper = styled(VStack)`
    gap: 40px;
`;
